var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TopImages"},[_c('StarrySky'),_c('div',[_c('img',{attrs:{"src":_vm.img}}),_c('h1',[_vm._v("重新定义未来生活的新形态")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }